import { api } from "./drogal-api"

export const getAccess = async(user, password) =>{
    
    try{

        if(user === ""){
            alert("Informe o usuário")
            return
        }
    
        if(password === ""){
            alert("Informe a senha")
            return
        }

        const isEmail = user.includes('@');

        const endpoint = isEmail ? api.addresses.loginCatterpilar : api.addresses.login;

        const data = isEmail 
        ? { email: user, password: password } 
        : { cpf: user, senha: password };  

        let response = await api.httpAccess.post(endpoint, data)

        const token = response.data;
        
       if (!token || typeof token !== "string") {
        alert("Login retornou token inválido.")
        return false
        }

        sessionStorage.setItem("token", token);
        return true

    }catch(error){
        
        if (error.response.status === 401) {
            alert("Usuário ou senha inválidos")                    
        }else if (error.response.status !== 200) {
            alert('Ocorreu um erro ao enviar a solicitação.');                  
        }   

        return false
    }    
}


export const removeLogin = async () =>{
    sessionStorage.removeItem("token")
}

export const isLoggedIn = () =>{
    let token = sessionStorage.getItem('token')
    return ((token !== undefined) && (token !== null) && (token !== ""))
}

export const decodeJwtPayload = () => { 

    let token = sessionStorage.getItem('token')   

    const payloadEncoded = token.split('.')[1];
    const payload = JSON.parse(atob(payloadEncoded));
    return payload;
}

